import {SinglePage} from '../../components/index'
import {Layout} from "../../layout";

export const Single = () => {
    return (
        <Layout>
            <SinglePage/>
        </Layout>
    );
};

